document.addEventListener("DOMContentLoaded", function () {
  // 1. 点击事件追踪（采用全局事件委托，支持动态加载的元素，性能极高）
  document.addEventListener("click", function (event) {
    const trackElement = event.target.closest("[data-track-click]");
    if (!trackElement) return;

    const eventName = trackElement.getAttribute("data-track-event") || "generic_click";

    if (typeof gtag === "function") {
      gtag("event", eventName, {
        transport: "beacon",
      });
      console.log("GA4 Click Tracked:", eventName);
    }
  });

  // 2. 曝光/浏览事件追踪（利用浏览器原生 IntersectionObserver，每个元素只触发一次）
  const observerOptions = {
    root: null, // 相对视口计算
    threshold: 0.5, // 元素进入视口达到 50% 时触发
  };

  const viewObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const viewEventName = element.getAttribute("data-track-view-event") || "section_view";

        if (typeof gtag === "function") {
          gtag("event", viewEventName, {
            transport: "beacon",
          });
          console.log("GA4 View Tracked:", viewEventName);
        }

        // 触发后立刻取消观察，确保每个板块在页面生命周期里只上报一次曝光
        observer.unobserve(element);
      }
    });
  }, observerOptions);

  // 绑定所有需要监听曝光的元素
  document.querySelectorAll("[data-track-view]").forEach(function (element) {
    viewObserver.observe(element);
  });
});
